/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import useHasRolePermission from './useHasRolePermission';

export const ssoConfigPermission = 'sso_config';

/**
 * This hook provides the boolean value based on logged in users sso config create permissions
 **/
export const useHasSSOCreatePermission = (): boolean => (
  useHasRolePermission(ssoConfigPermission, 'CREATE')
);

export default useHasSSOCreatePermission;
